<div mat-dialog-header class="title">
    {{ title }}
</div>
<div mat-dialog-content>
    <div class="upload-content">
        <file-upload
            class="profile-image-upload"
            accept=".png,.jpg,.jpeg"
            [labelText]="labelText"
            [(ngModel)]="file"
        ></file-upload>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!file" (click)="upload()">{{ uploadText }}</button>
</div>
